function dynamic_bar(timing) {
  if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/8262572277898") || window.location.pathname.includes("/tools/bundle-subscriptions/bundle/8271086256266")) {
    setTimeout(function() {   
      for (let m = 0; m < 100; m++) {    
        let find_element = document.querySelectorAll(".step2 .bundle-product-card__quantity-button-container--button")[0];
        if(find_element != undefined) {
          var e = document.querySelector("div.bundle-container > footer");
          let n = document.querySelectorAll(".bundle-text--emphasis")[0]?.parentElement.parentElement,
              i = document.querySelectorAll(".bundle-text--emphasis")[0]?.parentElement.nextElementSibling;
              i?.classList.add("hide"), i?.classList.add("total_quantity");
          let t = document.createElement("div");
          t.id = "dynamic_free_shipping";
          var r = document.createElement("div");
          r.id = "quantity_container";
          var l = document.createElement("div");
          (l.id = "free_shipping_label"), (l.innerHTML = "+$50 Shipping"), n?.insertBefore(l, i), (r.innerHTML = '<span id="dynamic_quantity"><b>8<b></span> <b>Item Minimum<b> &nbsp');
          var p = document.createElement("div");
          (p.id = "free_shipping_threshold_container"),
          (p.innerHTML = '|&nbsp Add $<span id="dynmaic_price">150.00</span> for Free Shipping'),
          t.appendChild(r),
          t.appendChild(p),
          e?.appendChild(t),
          document.querySelectorAll(".step2 .bundle-product-card__quantity-button-container--button").forEach((e) => {
              e.addEventListener("click", (e) => {
                  setTimeout(() => {
                      let e = document.querySelectorAll("#dynamic_free_shipping")[0],
                          n = document.querySelectorAll(".bundle-text--emphasis")[0].innerHTML,
                          i = document.querySelectorAll(".bundle-text--emphasis")[0].parentElement.nextElementSibling.nextElementSibling.innerHTML;
                      (i = parseInt(i.substring(0, 2))), (n = parseFloat(n.replace(/[^\d.-]/g, "")));
                      let t = 8 - i,
                          d = 150 - n;
                      if (((d = d.toFixed(2)), console.log("threshold_dynamic_amount 1", d), console.log("quantity_threshold 1", t), d <= 0))
                          (p.innerHTML = `/&nbsp✅ Free Shipping`), (l.innerHTML = "+Free Shipping"), e.style.setProperty("--pseudo-width", "100%");
                      else {
                          t <= 0 ? (p.innerHTML = `|&nbsp <b>Add $</b><span id="dynmaic_price"><b>${d}</span> for Free Shipping</b>`) : (p.innerHTML = `|&nbsp Add $<span id="dynmaic_price">${d}</span> for Free Shipping`),
                              (l.innerHTML = "+$50 Shipping");
                          let s = (n / 150) * 100;
                          e.style.setProperty("--pseudo-width", `${s}%`);
                      }
                      t > 1 ? (r.innerHTML = `<b>Add ${t} More Items</b> &nbsp`) : 1 == t ? (r.innerHTML = `<b>Add ${t} More Item</b> &nbsp`) : (r.innerHTML = `✅ 8 Item Minimum &nbsp`);
                  }, 500);
              });
          });
          let d = document.querySelectorAll(".button--primary")[0];
            "Continue" == d?.innerHTML &&
              d.addEventListener("click", (e) => {
              let n = document.querySelectorAll(".bundle-button")[0];
              "Back" == n.innerHTML &&
                n.addEventListener("click", (e) => {
                  setTimeout(() => {
                    document.querySelectorAll("#bundleapp-subscriptions-portal .bundle-product-card__quantity-button-container--button").forEach((e) => {
                        e.addEventListener("click", (e) => {
                            setTimeout(() => {
                                let e = document.querySelectorAll("#dynamic_free_shipping")[0],
                                    n = document.getElementById("quantity_container").innerHTML;
                                n = parseFloat(n.replace(/[^\d.-]/g, ""));
                                add_on_amount = parseFloat(document.querySelectorAll(".bundle-text--emphasis")[0].nextElementSibling.innerHTML.replace(/[^\d.-]/g, ""));
                                let i = document.querySelectorAll(".bundle-text--emphasis")[0].innerHTML;
                                i = parseFloat(i.replace(/[^\d.-]/g, ""));
                                let t = 0,
                                    d = document.querySelectorAll(".bundle-text--emphasis")[0].parentElement.nextElementSibling.nextElementSibling.innerHTML,
                                    s = 8 - (d = parseInt(d.substring(0, 2))),
                                    a = 150 - (t = add_on_amount ? i + add_on_amount : i);
                                if ((a = a.toFixed(2)) <= 0) (p.innerHTML = `/ &nbsp✅ Free Shipping`), (l.innerHTML = "+Free Shipping"), e.style.setProperty("--pseudo-width", "100%");
                                else {
                                    n >= 8
                                        ? (p.innerHTML = `|&nbsp <b>Add $</b><span id="dynmaic_price"><b>${a}</span> for Free Shipping</b>`)
                                        : (p.innerHTML = `|&nbsp Add $<span id="dynmaic_price">${a}</span> for Free Shipping`),
                                        s > 1 ? (r.innerHTML = `<b>Add ${s} More Items</b> &nbsp`) : 1 == s ? (r.innerHTML = `<b>Add ${s} More Item</b> &nbsp`) : (r.innerHTML = `✅ 8 Item Minimum &nbsp`),
                                        (l.innerHTML = "+$50 Shipping");
                                    let c = (t / 150) * 100;
                                    e.style.setProperty("--pseudo-width", `${c}%`);
                                }
                            }, 500);
                        });
                    });
                }, 500);
                }),
                setTimeout(() => {
                  document.querySelectorAll(".step3 .bundle-product-card__quantity-button-container--button").forEach((e) => {
                      e.addEventListener("click", (e) => {
                          setTimeout(() => {
                              let e = document.querySelectorAll("#dynamic_free_shipping")[0],
                                  n = document.getElementById("quantity_container").innerHTML;
                              n = parseFloat(n.replace(/[^\d.-]/g, ""));
                              add_on_amount = parseFloat(document.querySelectorAll(".bundle-text--emphasis")[0].nextElementSibling.innerHTML.replace(/[^\d.-]/g, ""));
                              let i = document.querySelectorAll(".bundle-text--emphasis")[0].innerHTML;
                              i = parseFloat(i.replace(/[^\d.-]/g, ""));
                              let t = 0,
                                  r = 150 - (t = add_on_amount ? i + add_on_amount : i);
                              if ((r = r.toFixed(2)) <= 0) (p.innerHTML = `/ &nbsp✅ Free Shipping`), (l.innerHTML = "+Free Shipping"), e.style.setProperty("--pseudo-width", "100%");
                              else {
                                  n >= 8 ? (p.innerHTML = `|&nbsp <b>Add $</b><span id="dynmaic_price"><b>${r}</span> for Free Shipping</b>`) : (p.innerHTML = `|&nbsp Add $<span id="dynmaic_price">${r}</span> for Free Shipping`),
                                      (l.innerHTML = "+$50 Shipping");
                                  let d = (t / 150) * 100;
                                  e.style.setProperty("--pseudo-width", `${d}%`);
                              }
                          }, 500);
                      });
                  });
                }, 500);
              });
            break;
          }
        }                    
      }, timing)
  }
}

var media_query = window.matchMedia("(max-width: 600px)");
if (media_query.matches) { 
  dynamic_bar(2000);
} else {
  dynamic_bar(1000);
}













